// @ts-nocheck
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";

import {
    chain,
    ValidateFields as baseValidateFields,
} from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const ValidateFields = createChainHandler("ValidateFields", chain, props => {
    const state = props.getState();
    props.result = {
        updatedUser: { ...getCurrentEditingUser(state) } as AccountModel,
        emailErrorMessage: state.pages.userSetup.emailErrorMessage,
        firstNameErrorMessage: state.pages.userSetup.firstNameErrorMessage,
        lastNameErrorMessage: state.pages.userSetup.lastNameErrorMessage,
    };
    // Starter Removed - validation - moved into new UserSetupUserInformation
});

replaceInChain(chain, baseValidateFields, ValidateFields);
